import React from "react";
import MobileFooter from "./MobileFooter";
import DesktopFooter from "./DesktopFooter";
import { useMediaQuery } from 'react-responsive'
import useViewport from "../Utils/useViewPort"


const Footer = () => {

  // const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  // const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  // const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  // const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
  const viewPort = useViewport();
  const isMobile = viewPort.width <= 1024;

  return (<>
    <div style={{background:"#f5f5f7"}}>
      {isMobile ? <MobileFooter /> : <></>}
      {!isMobile ? <DesktopFooter /> : <></>}
    </div>
  </>
  )

}

export default Footer;
